module.exports = __webpack_public_path__ + "img/spotify.496ca5c5.svg";